/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type FlashMessagesService from "ember-cli-flash/services/flash-messages";
import type { IntlService } from "ember-intl";
import { modifier } from "ember-modifier";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import type { ToastMessage } from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import WeightMeasuredJournalEvent from "parog-web/models/weight-measured-journal-event";
import type SemeiaSessionService from "parog-web/services/session";
import BMI from "parog-web/utils/bmi";
import formatNumberAsString from "parog-web/utils/format-number-as-string";

export default class WeightEditionFormComponent extends CrudJournalEventBaseComponent<WeightMeasuredJournalEvent> {
  @service declare session: SemeiaSessionService;
  @service declare flashMessages: FlashMessagesService;
  @service declare intl: IntlService;

  static forcDisplayName = "Mensurations";
  static fullComponentId = "measurements/weight-edition-form";

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = WeightMeasuredJournalEvent;

  journalEventProperties = ["occurredAt", "weight", "comments"];

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  get toastMessage(): ToastMessage | null {
    return this.session.patient
      ? {
          message: "Poids enregistré. Merci !",
          title: "Poids"
        }
      : super.toastMessage;
  }

  get forcDisplayName(): string {
    return this.session.patient ? "Mon poids" : super.forcDisplayName;
  }

  @action
  async save(): Promise<void> {
    this.changeset.set(
      "weight",
      formatNumberAsString(this.changeset.get("weight"))
    );

    await super.save();
  }

  get height(): number | undefined {
    return this.args.patient.lastHeightMeasuredJournalEvent?.height;
  }

  get bmi(): number | undefined {
    if (!this.height) return;

    return BMI(this.changeset.get("weight"), this.height);
  }

  focus = modifier(function (element: HTMLInputElement): void {
    (element.querySelector(".ui.input input") as HTMLInputElement).focus();
  });
}
